<div class="widget-documents">
    <h4 class="text-md-left text-center fw-500 mb-0 f-subtit pl-md-4 pb-2">{{ isLang?.annualReport }}</h4>
    <div class="blue-bg">
        <div class="select select-ver1" *ngIf="dataYear && year">
            <p class="year">{{ isLang?.selectYears }}</p>
            <ng-select2 [(ngModel)]="year" 
                        [data]="dataYear"
                        (valueChanged)="valueChanged($event)">
            </ng-select2>
        </div>
        <div class="text-center" *ngIf="dataPerAnnual">
            <img class="ic-docs" src="../../../assets/images/icon/file.svg" alt="">
            <p class="pt-2 pb-4">{{ dataPerAnnual?.title }}</p>
            <a target="_blank" 
                [href]="apiAsset + dataPerAnnual.filename" 
                class="d-inline-block dwnload">
                {{ isLang?.download }}
            </a>
        </div>
    </div>
</div>